<template>
    <div>
        <img id="img" :src="imgurl" align="center" v-if="imgurl">
        <h1 v-else>...</h1>
    </div>
</template>
<script>
    import axios from 'axios';
    export default {
        mixins: [],
        props: [],
        data() {
            return {
                uuid: null,
                img: null,
                src: null,
                imgurl: null,
                apiUrl: null,
                screensize: {
                    width: 0,
                    height: 0
                },
                bilddauer: 300
            }
        },
        computed: {},
        watch: {},
        methods: {
            refreshImage() {
                axios.get(this.apiUrl+"/api/imgurl?uuid="+this.uuid+"&last="+this.src).then(response => {
                    if (this.src == response.data) return this.refreshImage();
                    let imgurl = this.apiUrl+'/api/'+response.data+'&width='+this.screensize.width+'&height='+this.screensize.height;
                    var img = new Image();
                        img.onload = () => {
                            this.src = response.data;
                            this.imgurl = imgurl
                            setTimeout(() => {
                                this.refreshImage()
                            }, this.bilddauer*1000);
                        };
                        img.src = imgurl;
                }, error => {
                    console.log(error);
                    setTimeout(() => {
                        this.refreshImage()
                    }, this.bilddauer*1000);
                    alert("error");
                });
            }
        },
        mounted() {
            this.apiUrl = process.env.VUE_APP_API_URL;
            let uuid = window.location.pathname.slice(1);
            this.uuid = uuid;
            this.screensize = {
                width: window.innerWidth,
                height: window.innerHeight
            };
            if (this.uuid) {
                axios.get(this.apiUrl+"/api/dauer?uuid="+this.uuid).then(response => {
                    this.bilddauer = response.data.dauer;
                    this.refreshImage();
                });
            }
            
            // Einmal pro Stunde neu laden
            setTimeout(() => {
                window.location.reload();
            }, 3600000);
        },

    }
</script>
